import * as React from 'react'
import { Link } from 'react-router-dom'
import UIMessages from '../../../utils/ui-messages'
import HorizontalSelectorItemCustom from './HorizontalSelectorItemCustom'
import TabBar from '../../ui/entity/EntityTabBar'
import TabBarItem from '../../ui/entity/EntityTabBarItem'

export interface IRiderProfileStepSelectorProps {
  pathname: string
  riderId: string
}

const RiderProfileStepSelector = ({ pathname, riderId }: IRiderProfileStepSelectorProps) => {
  return (
    <div className='col-12 tab-selector'>
      <div className='flex bb-light-grey4'>
        <TabBar>
          <TabBarItem active={/\/info/.test(pathname)}>
            <Link to={`/riders/${riderId}/profile/info`}>{UIMessages.common.profile}</Link>
          </TabBarItem>
          <TabBarItem active={/\/recurringTrips/.test(pathname)}>
            <Link to={`/riders/${riderId}/profile/recurringTrips`}>{UIMessages.rider.recurringTrips.plannedTrips}</Link>
          </TabBarItem>
          <TabBarItem active={/\/location/.test(pathname)}>
            <Link to={`/riders/${riderId}/profile/location`}>{UIMessages.rider.locations}</Link>
          </TabBarItem>
          <TabBarItem active={/\/membership/.test(pathname)}>
            <Link to={`/riders/${riderId}/profile/membership`}>{UIMessages.common.membership}</Link>
          </TabBarItem>
          <TabBarItem active={/\/wallet/.test(pathname)}>
            <Link to={`/riders/${riderId}/profile/wallet`}>{UIMessages.common.wallet}</Link>
          </TabBarItem>
          <TabBarItem active={/\/promotions/.test(pathname)}>
            <Link to={`/riders/${riderId}/profile/promotions`}>{UIMessages.common.promotions}</Link>
          </TabBarItem>
          <TabBarItem active={/\/changeLog/.test(pathname)}>
            <Link to={`/riders/${riderId}/profile/changeLog`}>{UIMessages.rider.changeLog.riderChangeLog}</Link>
          </TabBarItem>
          <TabBarItem active={/\/driverFeedback/.test(pathname)}>
            <Link to={`/riders/${riderId}/profile/driverFeedback`}>{UIMessages.rider.feedback.driverFeedback}</Link>
          </TabBarItem>
          <TabBarItem active={/\/riderFeedback/.test(pathname)}>
            <Link to={`/riders/${riderId}/profile/riderFeedback`}>{UIMessages.rider.feedback.riderFeedback}</Link>
          </TabBarItem>
        </TabBar>

        <div style={{ flex: 4 }}>&nbsp;</div>

        <div className='absolute z1 left-0 right-0 bottom-0 bb-light-grey4' />
      </div>
    </div>
  )
}

export default RiderProfileStepSelector



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/RiderProfileStepSelector.tsx